module.exports = __webpack_public_path__ + "c11e637822d4d812e6a92bf67facbd35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_22.jpg
// module id = 1703
// module chunks = 5